import React, { useEffect, useRef } from "react";
import Messages from "./Messages";
import { setShowChat } from "../../store/actions";
import { connect } from "react-redux";
import { Tooltip } from "react-tooltip";
import NewMessage from "./NewMessage";

const PopupMessages = (props) => {
  const { setShowChatAction } = props;
  const containerRef = useRef(null);

  useEffect(() => {
    // Add class to body so CSS can hide the meeting timer on mobile
    document.body.classList.add("chat-panel-open");
    return () => {
      document.body.classList.remove("chat-panel-open");
    };
  }, []);

  // Resize the popup to fit within the visual viewport when the keyboard opens on mobile
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const handleViewportResize = () => {
      if (containerRef.current) {
        containerRef.current.style.height = `${viewport.height}px`;
        containerRef.current.style.top = `${viewport.offsetTop}px`;
      }
    };

    viewport.addEventListener("resize", handleViewportResize);
    viewport.addEventListener("scroll", handleViewportResize);

    return () => {
      viewport.removeEventListener("resize", handleViewportResize);
      viewport.removeEventListener("scroll", handleViewportResize);
    };
  }, []);

  const closeDiv = () => {
    setShowChatAction(false);
  };

  return (
    <div
      className="participants_popup_container open"
      ref={containerRef}
      style={{ display: "flex", flexDirection: "column", overflow: "hidden", maxWidth: "100vw", boxSizing: "border-box" }}
    >
      <Tooltip id="my-tooltip" />
      <div className="chat-popup-header">
        <p className="chat-popup-title">In-call Messages</p>
        <span
          className="chat-popup-close-btn"
          onClick={closeDiv}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Close"
        >
          ×
        </span>
      </div>
      <div
        className="chat-popup-body"
        style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", minWidth: 0, width: "100%" }}
      >
        <Messages />
        <NewMessage />
      </div>
    </div>
  );
};

const mapActionsToProps = (dispatch) => {
  return {
    setShowChatAction: (showChat) => dispatch(setShowChat(showChat)),
  };
};

export default connect(null, mapActionsToProps)(PopupMessages);